import { render, staticRenderFns } from "./GetStaff.vue?vue&type=template&id=0a25425c&scoped=true&"
import script from "./GetStaff.vue?vue&type=script&lang=js&"
export * from "./GetStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a25425c",
  null
  
)

export default component.exports